<div class="sectionbar">
  <app-system-status-nav [page]="page"></app-system-status-nav>
  <div class="sectionbar__actions"></div>
</div>
<div class="topbar">
  <h1>System status</h1>
</div>
<div class="pages">
  <div class="page__content">
    <div>
      @if (page == 'opkraevninger') {
        <app-system-status-opkraevninger></app-system-status-opkraevninger>
      }
      @if (page == 'eftersyn') {
        <app-system-status-eftersyn></app-system-status-eftersyn>
      }
    </div>
  </div>
</div>
